import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { fetchBidStatusFailure, fetchBidStatusSuccess } from "../actions/fetchBidStatusAction";


function* asyncFetchBidStatusSaga(action){

    try{
    yield put(clearErrors());
    let resFetBidStatus = yield call(_api.fetchBidStatusApi,{
        accessToken: action.payload.accessToken,
        product_id:action.payload.product_id,
    })
     yield put(fetchBidStatusSuccess({resFetBidStatus}));
    }catch(e){
        yield put(fetchBidStatusFailure({error:e}));
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* fetchBidStatusSaga(){
    yield takeLatest(types.FETCH_BID_STATUS_REQUEST,asyncFetchBidStatusSaga)
}